<template>
    <div @click="showDropdown = false">
        <p class="title is-size-6">
            {{ `${session.title} - ${session.shortCode}` }}
        </p>
        <nav class="level">
            <div class="level-item has-text-centered">
                <div>
                    <p v-t="'Sessions.players'" class="heading" />
                    <p class="title">
                        {{ session.participants.length }}
                    </p>
                </div>
            </div>
            <div class="level-item has-text-centered">
                <div>
                    <p v-t="'Sessions.questions_number'" class="heading" />
                    <p class="title">
                        {{ session.context.length }}
                    </p>
                </div>
            </div>
            <button
                class="button"
                aria-haspopup="true"
                aria-controls="dropdown-menu"
                @click="showDetails = !showDetails"
            >
                <span class="icon is-small">
                    <i class="fas fa-angle-down" aria-hidden="true" />
                </span>
            </button>
        </nav>
        <div
            v-if="$store.getters.isAdmin"
            :class="{ 'is-active': showDropdown }"
            class="dropdown"
            @click.stop="showDropdown = true"
        >
            <div class="dropdown-trigger">
                <button
                    class="button"
                    aria-haspopup="true"
                    aria-controls="dropdown-menu3"
                >
                    <span>Click me</span>
                    <span class="icon is-small">
                        <i class="fas fa-angle-down" aria-hidden="true"></i>
                    </span>
                </button>
            </div>
            <div id="dropdown-menu3" class="dropdown-menu" role="menu">
                <div class="dropdown-content">
                    <a
                        v-for="group in groups"
                        :key="group._id"
                        class="dropdown-item"
                        @click.stop="selectClass(group)"
                    >
                        {{ group.name }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { groupBy } from 'underscore';
import { assignCourseWork } from '@/services/API';
export default {
    name: 'SessionResume',
    components: {},
    props: {
        session: {
            type: Object,
            default: () => {
                return {};
            },
        },
        context: {
            type: Array,
            default: () => {
                return [];
            },
        },
        participants: {
            type: Array,
            default: () => {
                return [];
            },
        },
        title: {
            type: String,
            default: undefined,
        },
    },

    data() {
        return {
            showDetails: false,
            groups: this.$store.getters.groups,
            showDropdown: false,
        };
    },
    methods: {
        async selectClass(group) {
            this.showDropdown = false;
            let result = await assignCourseWork(
                this.session._id,
                group.course_id
            );
        },
    },
};
</script>

<style></style>
